import React from 'react';

var Progress = function Progress(_ref) {
  var percentage = _ref.percentage,
      label = _ref.label;
  return /*#__PURE__*/React.createElement("div", {
    className: "graph progress"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: percentage + '%'
    },
    className: "progress-bar"
  }, label));
};

Progress.defaultProps = {
  percentage: 0,
  label: null
};
export default Progress;